import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- Iframe-safe storage guard ---
// Če aplikacija teče v opaque-origin iframe-u (sandbox brez allow-same-origin),
// dostop do window.localStorage / window.sessionStorage vrže SecurityError.
// Zamenjamo z in-memory Map-om, da se app ne sesuje.
(function installStorageFallback() {
  const patch = (name) => {
    try {
      const s = window[name];
      // sprožimo dejansko preverjanje z branjem
      s && s.getItem("__probe__");
      return; // deluje – ne patchamo
    } catch (_) {
      const mem = new Map();
      const shim = {
        getItem: (k) => (mem.has(k) ? mem.get(k) : null),
        setItem: (k, v) => mem.set(k, String(v)),
        removeItem: (k) => mem.delete(k),
        clear: () => mem.clear(),
        key: (i) => Array.from(mem.keys())[i] || null,
        get length() { return mem.size; },
      };
      try {
        Object.defineProperty(window, name, {
          configurable: true,
          get: () => shim,
        });
      } catch (_) { /* ignore */ }
    }
  };
  patch("localStorage");
  patch("sessionStorage");
})();

// Register Service Worker for PWA (varno – iframe nima service worker dostopa)
try {
  if (window.self === window.top && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      try {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered:', registration.scope);
          })
          .catch((error) => {
            console.log('SW registration failed:', error);
          });
      } catch (_) { /* ignore */ }
    });
  }
} catch (_) { /* ignore SecurityError v sandboxed iframe-u */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
